var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApartment = function SvgApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.927246 59.4792V14.5H15.0939V0.333374H45.9064V28.6667H60.0731V59.4792H36.3439V45.3125H24.6564V59.4792H0.927246ZM3.40641 57H15.0939V45.3125H3.40641V57ZM3.40641 42.8334H15.0939V31.1459H3.40641V42.8334ZM3.40641 28.6667H15.0939V16.9792H3.40641V28.6667ZM17.5731 42.8334H29.2606V31.1459H17.5731V42.8334ZM17.5731 28.6667H29.2606V16.9792H17.5731V28.6667ZM17.5731 14.5H29.2606V2.81254H17.5731V14.5ZM31.7397 42.8334H43.4272V31.1459H31.7397V42.8334ZM31.7397 28.6667H43.4272V16.9792H31.7397V28.6667ZM31.7397 14.5H43.4272V2.81254H31.7397V14.5ZM45.9064 57H57.5939V45.3125H45.9064V57ZM45.9064 42.8334H57.5939V31.1459H45.9064V42.8334Z",
    fill: "#152A58"
  })));
};
export default SvgApartment;